module.exports = __webpack_public_path__ + "media/images/emblems/La_Chaux-coat_of_arms-8f2b0d754ce286ac50d971ac80d2679f.svg";